import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 质押导出字段
 */
class PledgeFields extends UltMeta {
    PLEDGE_ID = new Meta(1, "质押编号");
    PROJECT = new Meta(2, "关联项目");
    CONTRACT = new Meta(3, "关联合同");
    PLEDGOR_NAME = new Meta(4, "出质人");
    PLEDGEE_NAME = new Meta(5, "质权人");
    GOODS_TYPE = new Meta(13, "货物类型");
    GOODS_NAME = new Meta(6, "货物名称");
    MODEL = new Meta(7, "规格/型号");
    PLEDGE_NUM = new Meta(8, "质押数量/重量");
    PLEDGE_PRICE = new Meta(9, "质押金额（元）");
    EFFECTIVE_DATE = new Meta(10, "生效日期");
    CREATE_TIME = new Meta(11, "创建时间");
    UPDATE_TIME = new Meta(12, "更新时间");
}

export const PLEDGE_FIELDS = new PledgeFields();
